var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
export const USER_CENTRICS_ADJUST_SERVICE_ID = 'Jy6PlrM3';
export const USER_CENTRICS_ADJUST_SERVICE_NAME = 'Adjust';
export const getAdjustToken = () => {
    const token = process.env.NEXT_PUBLIC_ADJUST_SMART_BANNER_APP_TOKEN ||
        process.env.REACT_APP_ADJUST_APP_ACCESS_TOKEN;
    return token || '';
};
export const getUserCentricsAdjustConsentValue = (ucEvent) => {
    const _a = ucEvent.detail, _b = _a === void 0 ? {} : _a, { event = null } = _b, rest = __rest(_b, ["event"]);
    return event === 'consent_status' && rest[USER_CENTRICS_ADJUST_SERVICE_NAME];
};
//# sourceMappingURL=utils.js.map